module.exports = __webpack_public_path__ + "img/regulatory-three.c556ccc1.png";